import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerUser } from '../services/api';
import toast from 'react-hot-toast';
import { FiUser, FiMail, FiPhone, FiMapPin, FiLock } from 'react-icons/fi';

const SUBJECTS = ['Maths', 'Physics', 'Chemistry', 'Biology', 'English', 'Hindi', 'Computer Science', 'Social Studies', 'Telugu', 'Sanskrit'];
const CLASSES  = ['Class 1','Class 2','Class 3','Class 4','Class 5','Class 6','Class 7','Class 8','Class 9','Class 10','Class 11','Class 12'];
const BOARDS   = ['CBSE','ICSE','AP State Board','Telangana State Board','IB','IGCSE'];

const Register = () => {
  const navigate = useNavigate();
  const [role, setRole] = useState('tutor');
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: '', email: '', password: '', phone: '', city: '',
    tutorProfile:   { subjects: [], experience: '', feePerHour: '', qualification: '', bio: '', teachingMode: 'both' },
    studentProfile: { class: '', board: 'CBSE', subjects: [], requirement: '', budget: '' },
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const setT = (k, v) => setForm(f => ({ ...f, tutorProfile:   { ...f.tutorProfile,   [k]: v } }));
  const setS = (k, v) => setForm(f => ({ ...f, studentProfile: { ...f.studentProfile, [k]: v } }));
  const toggleSub = (profile, s) => {
    const list = profile === 'tutor' ? form.tutorProfile.subjects : form.studentProfile.subjects;
    const fn   = profile === 'tutor' ? setT : setS;
    fn('subjects', list.includes(s) ? list.filter(x => x !== s) : [...list, s]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await registerUser({ ...form, role });
      toast.success('Account created! Awaiting admin approval.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registration failed');
    } finally { setLoading(false); }
  };

  const inputStyle = { width: '100%', padding: '12px 14px 12px 42px', border: '1.5px solid var(--border)', borderRadius: '12px', fontSize: '14px', fontFamily: 'var(--font-body)' };
  const inputStyleNoIcon = { ...inputStyle, paddingLeft: '14px' };
  const labelStyle = { display: 'block', fontSize: '13px', fontWeight: 600, color: 'var(--dark)', marginBottom: '6px' };

  return (
    <div style={{ minHeight: '90vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', background: 'var(--lighter)' }}>
      <div style={{ width: '100%', maxWidth: '520px' }}>
        <div style={{ background: 'white', borderRadius: '28px', padding: '40px', boxShadow: 'var(--shadow-lg)' }}>
          <div style={{ textAlign: 'center', marginBottom: '28px' }}>
            <div style={{ width: '56px', height: '56px', borderRadius: '16px', background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px', fontSize: '26px' }}>✨</div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '24px', fontWeight: 800, marginBottom: '4px' }}>Create Account</h2>
            <p style={{ color: 'var(--gray)', fontSize: '13px' }}>Join TuitionConnect today</p>
          </div>

          {/* Role toggle */}
          <div style={{ display: 'flex', background: 'var(--light)', borderRadius: '14px', padding: '4px', marginBottom: '28px', gap: '4px' }}>
            {[{ id: 'tutor', label: '👨‍🏫 I\'m a Tutor' }, { id: 'student', label: '📚 I\'m a Student' }].map(r => (
              <button key={r.id} type="button" onClick={() => setRole(r.id)}
                style={{ flex: 1, padding: '11px', border: 'none', borderRadius: '11px', cursor: 'pointer', fontFamily: 'var(--font-body)', fontSize: '13px', fontWeight: 600, transition: 'all 0.2s',
                  background: role === r.id ? 'white' : 'transparent',
                  color: role === r.id ? 'var(--primary)' : 'var(--gray)',
                  boxShadow: role === r.id ? 'var(--shadow-sm)' : 'none',
                }}>{r.label}</button>
            ))}
          </div>

          <form onSubmit={handleSubmit}>
            {/* Basic info */}
            <div className="row g-3" style={{ marginBottom: '4px' }}>
              <div className="col-12">
                <label style={labelStyle}>Full Name</label>
                <div style={{ position: 'relative' }}>
                  <FiUser style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray)' }} />
                  <input type="text" required style={inputStyle} value={form.name} onChange={e => set('name', e.target.value)} placeholder="Your full name" />
                </div>
              </div>
              <div className="col-md-6">
                <label style={labelStyle}>Email</label>
                <div style={{ position: 'relative' }}>
                  <FiMail style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray)' }} />
                  <input type="email" required style={inputStyle} value={form.email} onChange={e => set('email', e.target.value)} placeholder="you@email.com" />
                </div>
              </div>
              <div className="col-md-6">
                <label style={labelStyle}>Phone</label>
                <div style={{ position: 'relative' }}>
                  <FiPhone style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray)' }} />
                  <input type="tel" required style={inputStyle} value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="+91 98765 43210" />
                </div>
              </div>
              <div className="col-12">
                <label style={labelStyle}>City / Area</label>
                <div style={{ position: 'relative' }}>
                  <FiMapPin style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray)' }} />
                  <input type="text" required style={inputStyle} value={form.city} onChange={e => set('city', e.target.value)} placeholder="e.g. Tirupati, Andhra Pradesh" />
                </div>
              </div>
            </div>

            {/* Divider */}
            <div style={{ borderTop: '1px dashed var(--border)', margin: '20px 0' }} />

            {/* Tutor profile */}
            {role === 'tutor' && (
              <div className="row g-3">
                <div className="col-12">
                  <label style={labelStyle}>Subjects You Teach</label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {SUBJECTS.map(s => (
                      <span key={s} onClick={() => toggleSub('tutor', s)} style={{
                        padding: '6px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s',
                        background: form.tutorProfile.subjects.includes(s) ? 'var(--primary)' : 'var(--light)',
                        color: form.tutorProfile.subjects.includes(s) ? 'white' : 'var(--gray)',
                        border: `1.5px solid ${form.tutorProfile.subjects.includes(s) ? 'var(--primary)' : 'var(--border)'}`,
                      }}>{s}</span>
                    ))}
                  </div>
                </div>
                <div className="col-md-6">
                  <label style={labelStyle}>Experience (years)</label>
                  <input type="number" min="0" style={inputStyleNoIcon} value={form.tutorProfile.experience} onChange={e => setT('experience', e.target.value)} placeholder="e.g. 5" />
                </div>
                <div className="col-md-6">
                  <label style={labelStyle}>Fee per hour (₹)</label>
                  <input type="number" min="0" style={inputStyleNoIcon} value={form.tutorProfile.feePerHour} onChange={e => setT('feePerHour', e.target.value)} placeholder="e.g. 500" />
                </div>
                <div className="col-md-6">
                  <label style={labelStyle}>Qualification</label>
                  <input type="text" style={inputStyleNoIcon} value={form.tutorProfile.qualification} onChange={e => setT('qualification', e.target.value)} placeholder="e.g. B.Tech, M.Sc" />
                </div>
                <div className="col-md-6">
                  <label style={labelStyle}>Teaching Mode</label>
                  <select style={inputStyleNoIcon} value={form.tutorProfile.teachingMode} onChange={e => setT('teachingMode', e.target.value)}>
                    <option value="online">Online</option>
                    <option value="offline">Offline</option>
                    <option value="both">Both</option>
                  </select>
                </div>
                <div className="col-12">
                  <label style={labelStyle}>Bio</label>
                  <textarea rows={3} style={{ ...inputStyleNoIcon, resize: 'vertical' }} value={form.tutorProfile.bio} onChange={e => setT('bio', e.target.value)} placeholder="Brief description about yourself..." />
                </div>
              </div>
            )}

            {/* Student profile */}
            {role === 'student' && (
              <div className="row g-3">
                <div className="col-md-6">
                  <label style={labelStyle}>Class</label>
                  <select style={inputStyleNoIcon} value={form.studentProfile.class} onChange={e => setS('class', e.target.value)}>
                    <option value="">Select class</option>
                    {CLASSES.map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
                <div className="col-md-6">
                  <label style={labelStyle}>Board</label>
                  <select style={inputStyleNoIcon} value={form.studentProfile.board} onChange={e => setS('board', e.target.value)}>
                    {BOARDS.map(b => <option key={b}>{b}</option>)}
                  </select>
                </div>
                <div className="col-12">
                  <label style={labelStyle}>Subjects Needed</label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {SUBJECTS.map(s => (
                      <span key={s} onClick={() => toggleSub('student', s)} style={{
                        padding: '6px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s',
                        background: form.studentProfile.subjects.includes(s) ? 'var(--success)' : 'var(--light)',
                        color: form.studentProfile.subjects.includes(s) ? 'white' : 'var(--gray)',
                        border: `1.5px solid ${form.studentProfile.subjects.includes(s) ? 'var(--success)' : 'var(--border)'}`,
                      }}>{s}</span>
                    ))}
                  </div>
                </div>
                <div className="col-12">
                  <label style={labelStyle}>Requirement Details</label>
                  <textarea rows={3} style={{ ...inputStyleNoIcon, resize: 'vertical' }} value={form.studentProfile.requirement} onChange={e => setS('requirement', e.target.value)} placeholder="Describe what kind of tutoring you need..." />
                </div>
                <div className="col-12">
                  <label style={labelStyle}>Max Budget per hour (₹)</label>
                  <input type="number" min="0" style={inputStyleNoIcon} value={form.studentProfile.budget} onChange={e => setS('budget', e.target.value)} placeholder="e.g. 500" />
                </div>
              </div>
            )}

            <div style={{ borderTop: '1px dashed var(--border)', margin: '20px 0' }} />

            <div>
              <label style={labelStyle}>Password</label>
              <div style={{ position: 'relative' }}>
                <FiLock style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray)' }} />
                <input type="password" required minLength={8} style={inputStyle} value={form.password} onChange={e => set('password', e.target.value)} placeholder="Minimum 8 characters" />
              </div>
            </div>

            <button type="submit" disabled={loading} className="btn-primary-custom" style={{ width: '100%', padding: '14px', marginTop: '24px' }}>
              {loading ? <><span className="spinner-border spinner-border-sm me-2" />Creating account...</> : 'Create Account ✨'}
            </button>
          </form>

          <p style={{ textAlign: 'center', fontSize: '13px', color: 'var(--gray)', marginTop: '16px', marginBottom: 0 }}>
            Already have an account? <Link to="/login" style={{ color: 'var(--primary)', fontWeight: 600, textDecoration: 'none' }}>Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
